'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
exports['default'] = Contact;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _domClasslist = require('dom-classlist');

var _domClasslist2 = _interopRequireDefault(_domClasslist);

var _gsap = require('gsap');

var _gsap2 = _interopRequireDefault(_gsap);

var _pubsub = require('pubsub');

var _pubsub2 = _interopRequireDefault(_pubsub);

var _formSerialize = require('form-serialize');

var _formSerialize2 = _interopRequireDefault(_formSerialize);

var _xhr = require('xhr');

var _xhr2 = _interopRequireDefault(_xhr);

var _ajaxRequest = require('ajaxRequest');

var _ajaxRequest2 = _interopRequireDefault(_ajaxRequest);

function Contact() {

	var _contactForm = document.querySelector('#contact-form');
	if (!_contactForm) return;

	var _btSubmit = _contactForm.querySelector('.bt'),
	    _inputs = _contactForm.querySelectorAll('input[type="text"], textarea, input[type="text"], div.select-outer'),
	    // Add gestion Select & inputs[type=file]
	_confirmField = _contactForm.querySelector('.confirm'),
	    _iframe = _contactForm.querySelector('#iframeContent');
	var isLoading = false,
	    to = undefined;

	/**	
  * 		Cancel the natural submit of form
  * 		& Trigger the SubmitForm fct
  */
	var addHandlers = function addHandlers(e) {
		_contactForm.addEventListener('submit', function (e) {
			e.preventDefault();
			submitForm();
		});
	};
	addHandlers();
	/**
  * 		Check if form is ready
  * 		Unset every field error
  * 		Exec reCaptcha & Set the captcha's responses token
  * 		Then submit Form
  */
	var submitForm = function submitForm(e) {
		// Break If Form has been sent Or isLoading
		if ((0, _domClasslist2['default'])(_btSubmit).contains('ok')) {
			return;
		}
		if (isLoading) {
			return;
		}
		isLoading = true;

		// Reset Fields Errors
		(0, _domClasslist2['default'])(_btSubmit).remove('ok');
		(0, _domClasslist2['default'])(_btSubmit).remove('ko');
		(0, _domClasslist2['default'])(_confirmField).remove('active');
		var _iteratorNormalCompletion = true;
		var _didIteratorError = false;
		var _iteratorError = undefined;

		try {
			for (var _iterator = _inputs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
				var input = _step.value;

				toggleError(input, true);
			}

			// Recaptcha v3
		} catch (err) {
			_didIteratorError = true;
			_iteratorError = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion && _iterator['return']) {
					_iterator['return']();
				}
			} finally {
				if (_didIteratorError) {
					throw _iteratorError;
				}
			}
		}

		var tokenRecaptcha = _contactForm.querySelector("input[name='g-recaptcha'");

		if (tokenRecaptcha) {
			grecaptcha.execute(tokenRecaptcha.value, { action: 'homepage' }).then(function (token) {
				var tokenResponse = _contactForm.querySelector("input[name='g-recaptcha-response']");
				tokenResponse.value = token;

				_contactForm.submit();
			});
		} else {
			_contactForm.submit();
		}
	};
	/**
  * 		Check if form has been submited
  * 		Unset every field error
  * 		Check the Response on Iframe
  * 		& Set OR/AND Unset error 
  */
	_iframe.onload = function () {

		isLoading = false;

		var _iteratorNormalCompletion2 = true;
		var _didIteratorError2 = false;
		var _iteratorError2 = undefined;

		try {
			for (var _iterator2 = _inputs[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
				var input = _step2.value;

				toggleError(input, true);
			}
		} catch (err) {
			_didIteratorError2 = true;
			_iteratorError2 = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion2 && _iterator2['return']) {
					_iterator2['return']();
				}
			} finally {
				if (_didIteratorError2) {
					throw _iteratorError2;
				}
			}
		}

		var iframeContent = _iframe.contentWindow || _iframe.contentDocument,
		    iframeText = iframeContent.document.body.innerHTML ? iframeContent.document.body.innerHTML : '';

		if (!iframeText) {
			return false;
		}

		var response = JSON.parse(iframeText);

		var _iteratorNormalCompletion3 = true;
		var _didIteratorError3 = false;
		var _iteratorError3 = undefined;

		try {
			for (var _iterator3 = response[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
				var el = _step3.value;

				var field = _contactForm.querySelector('[name=' + el.field + ']');

				switch (el.level) {
					case 'error':

						if (!field) continue;

						toggleError(field);

						(0, _domClasslist2['default'])(_btSubmit).add('ko');
						_confirmField.innerHTML = el.msg;
						clearTimeout(to);
						to = setTimeout(function () {
							(0, _domClasslist2['default'])(_btSubmit).remove('ko');
						}, 1500);
						break;
					case 'success':
						if (el.msg == "refresh") {
							window.location.reload(true);
							return;
						}

						(0, _domClasslist2['default'])(_btSubmit).add('ok');
						if (el.field == "btn") _btSubmit.setAttribute("value", el.msg);
						if (el.field == "msg") _confirmField.innerHTML = el.msg;
						var _iteratorNormalCompletion4 = true;
						var _didIteratorError4 = false;
						var _iteratorError4 = undefined;

						try {
							for (var _iterator4 = _inputs[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
								var input = _step4.value;

								input.disabled = true;
								input.readOnly = true;
							}
						} catch (err) {
							_didIteratorError4 = true;
							_iteratorError4 = err;
						} finally {
							try {
								if (!_iteratorNormalCompletion4 && _iterator4['return']) {
									_iterator4['return']();
								}
							} finally {
								if (_didIteratorError4) {
									throw _iteratorError4;
								}
							}
						}

						break;
				}
			}
		} catch (err) {
			_didIteratorError3 = true;
			_iteratorError3 = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion3 && _iterator3['return']) {
					_iterator3['return']();
				}
			} finally {
				if (_didIteratorError3) {
					throw _iteratorError3;
				}
			}
		}
	};

	/**
  * 		Toggle Error On Fields
  * 		Or Force to Remove Error
  */
	var toggleError = function toggleError(field) {
		var forceRemove = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];

		switch (field.tagName) {
			case 'SELECT':
				toggleSelectError(field, forceRemove);
				break;
			default:
				switch (field.type) {
					case 'file':
						toggleFileError(field, forceRemove);
						break;
					default:
						toggleTextError(field, forceRemove);
						break;
				}
				break;
		}
	};

	var toggleSelectError = function toggleSelectError(field, forceRemove) {
		var selectWrapper = field.parentNode;
		if (forceRemove) {
			(0, _domClasslist2['default'])(selectWrapper).remove('error');
		} else {
			(0, _domClasslist2['default'])(selectWrapper).toggle('error');
		}
	};

	var toggleFileError = function toggleFileError(field, forceRemove) {
		if (forceRemove) {
			(0, _domClasslist2['default'])(field).remove('error');
		} else {
			(0, _domClasslist2['default'])(field).toggle('error');
		}
	};

	var toggleTextError = function toggleTextError(field, forceRemove) {
		if (forceRemove) {
			(0, _domClasslist2['default'])(field).remove('error');
		} else {
			(0, _domClasslist2['default'])(field).toggle('error');
		}
	};
}

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9Vc2Vycy9iYWJlL1dvcmsvdjIuZG91YmxlZy51bHRyYW5vaXIuY29tL2Fzc2V0cy9zY3JpcHRzL3BhcnRpYWxzL2NvbnRhY3QuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7cUJBUXdCLE9BQU87Ozs7NEJBUlQsZUFBZTs7OztvQkFDcEIsTUFBTTs7OztzQkFDSixRQUFROzs7OzZCQUNMLGdCQUFnQjs7OzttQkFDdEIsS0FBSzs7OzsyQkFDRCxhQUFhOzs7O0FBR2xCLFNBQVMsT0FBTyxHQUFHOztBQUVqQyxLQUFNLFlBQVksR0FBRyxRQUFRLENBQUMsYUFBYSxDQUFDLGVBQWUsQ0FBQyxDQUFBO0FBQzVELEtBQUcsQ0FBQyxZQUFZLEVBQUUsT0FBTzs7QUFFekIsS0FBTSxTQUFTLEdBQUcsWUFBWSxDQUFDLGFBQWEsQ0FBQyxLQUFLLENBQUM7S0FDakQsT0FBTyxHQUFHLFlBQVksQ0FBQyxnQkFBZ0IsQ0FBQyxvRUFBb0UsQ0FBQzs7QUFDN0csY0FBYSxHQUFHLFlBQVksQ0FBQyxhQUFhLENBQUMsVUFBVSxDQUFDO0tBQUUsT0FBTyxHQUFHLFlBQVksQ0FBQyxhQUFhLENBQUMsZ0JBQWdCLENBQUMsQ0FBQztBQUNqSCxLQUFJLFNBQVMsR0FBRyxLQUFLO0tBQ25CLEVBQUUsWUFBQSxDQUFBOzs7Ozs7QUFNSixLQUFNLFdBQVcsR0FBRyxTQUFkLFdBQVcsQ0FBSSxDQUFDLEVBQUc7QUFDeEIsY0FBWSxDQUFDLGdCQUFnQixDQUFDLFFBQVEsRUFBRSxVQUFTLENBQUMsRUFBQztBQUNsRCxJQUFDLENBQUMsY0FBYyxFQUFFLENBQUM7QUFDbkIsYUFBVSxFQUFFLENBQUM7R0FDYixDQUFDLENBQUM7RUFDSCxDQUFBO0FBQ0QsWUFBVyxFQUFFLENBQUE7Ozs7Ozs7QUFPYixLQUFNLFVBQVUsR0FBRyxTQUFiLFVBQVUsQ0FBSSxDQUFDLEVBQUc7O0FBRXZCLE1BQUcsK0JBQVUsU0FBUyxDQUFDLENBQUMsUUFBUSxDQUFDLElBQUksQ0FBQyxFQUFDO0FBQ3RDLFVBQU87R0FDUDtBQUNELE1BQUcsU0FBUyxFQUFDO0FBQ1osVUFBTztHQUNQO0FBQ0QsV0FBUyxHQUFHLElBQUksQ0FBQzs7O0FBR2pCLGlDQUFVLFNBQVMsQ0FBQyxDQUFDLE1BQU0sQ0FBQyxJQUFJLENBQUMsQ0FBQTtBQUNqQyxpQ0FBVSxTQUFTLENBQUMsQ0FBQyxNQUFNLENBQUMsSUFBSSxDQUFDLENBQUE7QUFDakMsaUNBQVUsYUFBYSxDQUFDLENBQUMsTUFBTSxDQUFDLFFBQVEsQ0FBQyxDQUFBOzs7Ozs7QUFDekMsd0JBQW1CLE9BQU8sOEhBQUM7UUFBakIsS0FBSzs7QUFDZCxlQUFXLENBQUMsS0FBSyxFQUFFLElBQUksQ0FBQyxDQUFDO0lBQ3pCOzs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFHRCxNQUFJLGNBQWMsR0FBRyxZQUFZLENBQUMsYUFBYSxDQUFDLDBCQUEwQixDQUFDLENBQUM7O0FBRTVFLE1BQUcsY0FBYyxFQUFDO0FBQ2pCLGFBQVUsQ0FBQyxPQUFPLENBQUMsY0FBYyxDQUFDLEtBQUssRUFBRSxFQUFDLE1BQU0sRUFBRSxVQUFVLEVBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQyxVQUFTLEtBQUssRUFBQztBQUNsRixRQUFJLGFBQWEsR0FBRyxZQUFZLENBQUMsYUFBYSxDQUFDLG9DQUFvQyxDQUFDLENBQUM7QUFDckYsaUJBQWEsQ0FBQyxLQUFLLEdBQUcsS0FBSyxDQUFDOztBQUU1QixnQkFBWSxDQUFDLE1BQU0sRUFBRSxDQUFDO0lBQ3RCLENBQUMsQ0FBQztHQUNILE1BQUk7QUFDSixlQUFZLENBQUMsTUFBTSxFQUFFLENBQUM7R0FDdEI7RUFFRCxDQUFBOzs7Ozs7O0FBT0QsUUFBTyxDQUFDLE1BQU0sR0FBRyxZQUFNOztBQUV0QixXQUFTLEdBQUcsS0FBSyxDQUFDOzs7Ozs7O0FBRWxCLHlCQUFtQixPQUFPLG1JQUFDO1FBQWpCLEtBQUs7O0FBQ2QsZUFBVyxDQUFDLEtBQUssRUFBRSxJQUFJLENBQUMsQ0FBQztJQUN6Qjs7Ozs7Ozs7Ozs7Ozs7OztBQUVELE1BQUksYUFBYSxHQUFJLE9BQU8sQ0FBQyxhQUFhLElBQUksT0FBTyxDQUFDLGVBQWUsQUFBQztNQUNyRSxVQUFVLEdBQUcsQUFBQyxhQUFhLENBQUMsUUFBUSxDQUFDLElBQUksQ0FBQyxTQUFTLEdBQUksYUFBYSxDQUFDLFFBQVEsQ0FBQyxJQUFJLENBQUMsU0FBUyxHQUFHLEVBQUUsQ0FBQzs7QUFFbkcsTUFBRyxDQUFDLFVBQVUsRUFBQztBQUNkLFVBQU8sS0FBSyxDQUFDO0dBQ2I7O0FBRUQsTUFBTSxRQUFRLEdBQUcsSUFBSSxDQUFDLEtBQUssQ0FBQyxVQUFVLENBQUMsQ0FBQzs7Ozs7OztBQUV4Qyx5QkFBZ0IsUUFBUSxtSUFBQztRQUFmLEVBQUU7O0FBRVgsUUFBSSxLQUFLLEdBQUcsWUFBWSxDQUFDLGFBQWEsQ0FBQyxRQUFRLEdBQUMsRUFBRSxDQUFDLEtBQUssR0FBQyxHQUFHLENBQUMsQ0FBQzs7QUFFOUQsWUFBTyxFQUFFLENBQUMsS0FBSztBQUNkLFVBQUssT0FBTzs7QUFFWCxVQUFHLENBQUMsS0FBSyxFQUFFLFNBQVM7O0FBRXBCLGlCQUFXLENBQUMsS0FBSyxDQUFDLENBQUM7O0FBRW5CLHFDQUFVLFNBQVMsQ0FBQyxDQUFDLEdBQUcsQ0FBQyxJQUFJLENBQUMsQ0FBQztBQUMvQixtQkFBYSxDQUFDLFNBQVMsR0FBRyxFQUFFLENBQUMsR0FBRyxDQUFDO0FBQ2pDLGtCQUFZLENBQUMsRUFBRSxDQUFDLENBQUE7QUFDaEIsUUFBRSxHQUFHLFVBQVUsQ0FBQyxZQUFVO0FBQUMsc0NBQVUsU0FBUyxDQUFDLENBQUMsTUFBTSxDQUFDLElBQUksQ0FBQyxDQUFDO09BQUMsRUFBRSxJQUFJLENBQUMsQ0FBQTtBQUN0RSxZQUFNO0FBQUEsQUFDTixVQUFLLFNBQVM7QUFDYixVQUFHLEVBQUUsQ0FBQyxHQUFHLElBQUksU0FBUyxFQUFDO0FBQ3RCLGFBQU0sQ0FBQyxRQUFRLENBQUMsTUFBTSxDQUFDLElBQUksQ0FBQyxDQUFDO0FBQzdCLGNBQU87T0FDUDs7QUFFRCxxQ0FBVSxTQUFTLENBQUMsQ0FBQyxHQUFHLENBQUMsSUFBSSxDQUFDLENBQUE7QUFDOUIsVUFBRyxFQUFFLENBQUMsS0FBSyxJQUFJLEtBQUssRUFBQyxTQUFTLENBQUMsWUFBWSxDQUFDLE9BQU8sRUFBRSxFQUFFLENBQUMsR0FBRyxDQUFDLENBQUE7QUFDNUQsVUFBRyxFQUFFLENBQUMsS0FBSyxJQUFJLEtBQUssRUFBQyxhQUFhLENBQUMsU0FBUyxHQUFHLEVBQUUsQ0FBQyxHQUFHLENBQUM7Ozs7OztBQUN0RCw2QkFBbUIsT0FBTyxtSUFBQztZQUFqQixLQUFLOztBQUNkLGFBQUssQ0FBQyxRQUFRLEdBQUcsSUFBSSxDQUFDO0FBQ3RCLGFBQUssQ0FBQyxRQUFRLEdBQUcsSUFBSSxDQUFDO1FBQ3RCOzs7Ozs7Ozs7Ozs7Ozs7O0FBRUYsWUFBTTtBQUFBLEtBQ047SUFDRDs7Ozs7Ozs7Ozs7Ozs7O0VBRUQsQ0FBQTs7Ozs7O0FBTUQsS0FBTSxXQUFXLEdBQUcsU0FBZCxXQUFXLENBQUksS0FBSyxFQUF3QjtNQUF0QixXQUFXLHlEQUFHLEtBQUs7O0FBQzlDLFVBQU8sS0FBSyxDQUFDLE9BQU87QUFDbkIsUUFBSyxRQUFRO0FBQ1oscUJBQWlCLENBQUMsS0FBSyxFQUFDLFdBQVcsQ0FBQyxDQUFDO0FBQ3RDLFVBQU07QUFBQSxBQUNOO0FBQ0MsWUFBTyxLQUFLLENBQUMsSUFBSTtBQUNoQixVQUFLLE1BQU07QUFDVixxQkFBZSxDQUFDLEtBQUssRUFBQyxXQUFXLENBQUMsQ0FBQztBQUNwQyxZQUFNO0FBQUEsQUFDTjtBQUNDLHFCQUFlLENBQUMsS0FBSyxFQUFDLFdBQVcsQ0FBQyxDQUFDO0FBQ3BDLFlBQU07QUFBQSxLQUNOO0FBQ0YsVUFBTTtBQUFBLEdBQ047RUFDRCxDQUFBOztBQUVELEtBQU0saUJBQWlCLEdBQUcsU0FBcEIsaUJBQWlCLENBQUksS0FBSyxFQUFDLFdBQVcsRUFBRztBQUM5QyxNQUFJLGFBQWEsR0FBRyxLQUFLLENBQUMsVUFBVSxDQUFDO0FBQ3JDLE1BQUcsV0FBVyxFQUFDO0FBQ2Qsa0NBQVUsYUFBYSxDQUFDLENBQUMsTUFBTSxDQUFDLE9BQU8sQ0FBQyxDQUFDO0dBQ3pDLE1BQUk7QUFDSixrQ0FBVSxhQUFhLENBQUMsQ0FBQyxNQUFNLENBQUMsT0FBTyxDQUFDLENBQUM7R0FDekM7RUFDRCxDQUFBOztBQUVELEtBQU0sZUFBZSxHQUFHLFNBQWxCLGVBQWUsQ0FBSSxLQUFLLEVBQUMsV0FBVyxFQUFHO0FBQzVDLE1BQUcsV0FBVyxFQUFDO0FBQ2Qsa0NBQVUsS0FBSyxDQUFDLENBQUMsTUFBTSxDQUFDLE9BQU8sQ0FBQyxDQUFDO0dBQ2pDLE1BQUk7QUFDSixrQ0FBVSxLQUFLLENBQUMsQ0FBQyxNQUFNLENBQUMsT0FBTyxDQUFDLENBQUM7R0FDakM7RUFDRCxDQUFBOztBQUVELEtBQU0sZUFBZSxHQUFHLFNBQWxCLGVBQWUsQ0FBSSxLQUFLLEVBQUMsV0FBVyxFQUFHO0FBQzVDLE1BQUcsV0FBVyxFQUFDO0FBQ2Qsa0NBQVUsS0FBSyxDQUFDLENBQUMsTUFBTSxDQUFDLE9BQU8sQ0FBQyxDQUFDO0dBQ2pDLE1BQUk7QUFDSixrQ0FBVSxLQUFLLENBQUMsQ0FBQyxNQUFNLENBQUMsT0FBTyxDQUFDLENBQUM7R0FDakM7RUFDRCxDQUFBO0NBQ0QiLCJmaWxlIjoiL1VzZXJzL2JhYmUvV29yay92Mi5kb3VibGVnLnVsdHJhbm9pci5jb20vYXNzZXRzL3NjcmlwdHMvcGFydGlhbHMvY29udGFjdC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBjbGFzc0xpc3QgZnJvbSAnZG9tLWNsYXNzbGlzdCc7XG5pbXBvcnQgZ3NhcCBmcm9tICdnc2FwJztcbmltcG9ydCBwdWJzdWIgZnJvbSAncHVic3ViJztcbmltcG9ydCBzZXJpYWxpemUgZnJvbSAnZm9ybS1zZXJpYWxpemUnO1xuaW1wb3J0IHhociBmcm9tICd4aHInO1xuaW1wb3J0IEFqYXhSZXEgZnJvbSAnYWpheFJlcXVlc3QnO1xuXG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIENvbnRhY3QoKSB7XG5cdFx0XG5cdGNvbnN0IF9jb250YWN0Rm9ybSA9IGRvY3VtZW50LnF1ZXJ5U2VsZWN0b3IoJyNjb250YWN0LWZvcm0nKVxuXHRpZighX2NvbnRhY3RGb3JtKSByZXR1cm47XG5cblx0Y29uc3QgX2J0U3VibWl0ID0gX2NvbnRhY3RGb3JtLnF1ZXJ5U2VsZWN0b3IoJy5idCcpXG5cdCxcdF9pbnB1dHMgPSBfY29udGFjdEZvcm0ucXVlcnlTZWxlY3RvckFsbCgnaW5wdXRbdHlwZT1cInRleHRcIl0sIHRleHRhcmVhLCBpbnB1dFt0eXBlPVwidGV4dFwiXSwgZGl2LnNlbGVjdC1vdXRlcicpIFx0Ly8gQWRkIGdlc3Rpb24gU2VsZWN0ICYgaW5wdXRzW3R5cGU9ZmlsZV1cblx0LFx0X2NvbmZpcm1GaWVsZCA9IF9jb250YWN0Rm9ybS5xdWVyeVNlbGVjdG9yKCcuY29uZmlybScpLFx0X2lmcmFtZSA9IF9jb250YWN0Rm9ybS5xdWVyeVNlbGVjdG9yKCcjaWZyYW1lQ29udGVudCcpO1xuXHRsZXRcdGlzTG9hZGluZyA9IGZhbHNlXG5cdCxcdHRvXG5cblx0LyoqXHRcblx0ICogXHRcdENhbmNlbCB0aGUgbmF0dXJhbCBzdWJtaXQgb2YgZm9ybVxuXHQgKiBcdFx0JiBUcmlnZ2VyIHRoZSBTdWJtaXRGb3JtIGZjdFxuXHQgKi9cblx0Y29uc3QgYWRkSGFuZGxlcnMgPSAoZSk9Pntcblx0XHRfY29udGFjdEZvcm0uYWRkRXZlbnRMaXN0ZW5lcignc3VibWl0JywgZnVuY3Rpb24oZSl7XG5cdFx0XHRlLnByZXZlbnREZWZhdWx0KCk7XG5cdFx0XHRzdWJtaXRGb3JtKCk7XG5cdFx0fSk7XG5cdH1cblx0YWRkSGFuZGxlcnMoKVxuXHQvKipcblx0ICogXHRcdENoZWNrIGlmIGZvcm0gaXMgcmVhZHlcblx0ICogXHRcdFVuc2V0IGV2ZXJ5IGZpZWxkIGVycm9yXG5cdCAqIFx0XHRFeGVjIHJlQ2FwdGNoYSAmIFNldCB0aGUgY2FwdGNoYSdzIHJlc3BvbnNlcyB0b2tlblxuXHQgKiBcdFx0VGhlbiBzdWJtaXQgRm9ybVxuXHQgKi9cblx0Y29uc3Qgc3VibWl0Rm9ybSA9IChlKT0+e1xuXHRcdC8vIEJyZWFrIElmIEZvcm0gaGFzIGJlZW4gc2VudCBPciBpc0xvYWRpbmdcblx0XHRpZihjbGFzc0xpc3QoX2J0U3VibWl0KS5jb250YWlucygnb2snKSl7XG5cdFx0XHRyZXR1cm47XG5cdFx0fVxuXHRcdGlmKGlzTG9hZGluZyl7XG5cdFx0XHRyZXR1cm47XG5cdFx0fSBcblx0XHRpc0xvYWRpbmcgPSB0cnVlO1xuXG5cdFx0Ly8gUmVzZXQgRmllbGRzIEVycm9yc1xuXHRcdGNsYXNzTGlzdChfYnRTdWJtaXQpLnJlbW92ZSgnb2snKVxuXHRcdGNsYXNzTGlzdChfYnRTdWJtaXQpLnJlbW92ZSgna28nKVxuXHRcdGNsYXNzTGlzdChfY29uZmlybUZpZWxkKS5yZW1vdmUoJ2FjdGl2ZScpXG5cdFx0Zm9yKGNvbnN0IGlucHV0IG9mIF9pbnB1dHMpe1xuXHRcdFx0dG9nZ2xlRXJyb3IoaW5wdXQsIHRydWUpO1xuXHRcdH1cblxuXHRcdC8vIFJlY2FwdGNoYSB2M1xuXHRcdHZhciB0b2tlblJlY2FwdGNoYSA9IF9jb250YWN0Rm9ybS5xdWVyeVNlbGVjdG9yKFwiaW5wdXRbbmFtZT0nZy1yZWNhcHRjaGEnXCIpO1xuXHRcdCBcblx0XHRpZih0b2tlblJlY2FwdGNoYSl7IFxuXHRcdFx0Z3JlY2FwdGNoYS5leGVjdXRlKHRva2VuUmVjYXB0Y2hhLnZhbHVlLCB7YWN0aW9uOiAnaG9tZXBhZ2UnfSkudGhlbihmdW5jdGlvbih0b2tlbil7XG5cdFx0XHRcdHZhciB0b2tlblJlc3BvbnNlID0gX2NvbnRhY3RGb3JtLnF1ZXJ5U2VsZWN0b3IoXCJpbnB1dFtuYW1lPSdnLXJlY2FwdGNoYS1yZXNwb25zZSddXCIpO1xuXHRcdFx0XHR0b2tlblJlc3BvbnNlLnZhbHVlID0gdG9rZW47XG5cdFxuXHRcdFx0XHRfY29udGFjdEZvcm0uc3VibWl0KCk7IFxuXHRcdFx0fSk7XHQgXG5cdFx0fWVsc2V7XG5cdFx0XHRfY29udGFjdEZvcm0uc3VibWl0KCk7IFxuXHRcdH1cblx0XHRcblx0fVxuXHQvKipcblx0ICogXHRcdENoZWNrIGlmIGZvcm0gaGFzIGJlZW4gc3VibWl0ZWRcblx0ICogXHRcdFVuc2V0IGV2ZXJ5IGZpZWxkIGVycm9yXG5cdCAqIFx0XHRDaGVjayB0aGUgUmVzcG9uc2Ugb24gSWZyYW1lXG5cdCAqIFx0XHQmIFNldCBPUi9BTkQgVW5zZXQgZXJyb3IgXG5cdCAqL1xuXHRfaWZyYW1lLm9ubG9hZCA9ICgpID0+IHtcblxuXHRcdGlzTG9hZGluZyA9IGZhbHNlO1xuXG5cdFx0Zm9yKGNvbnN0IGlucHV0IG9mIF9pbnB1dHMpe1xuXHRcdFx0dG9nZ2xlRXJyb3IoaW5wdXQsIHRydWUpO1xuXHRcdH1cblxuXHRcdHZhciBpZnJhbWVDb250ZW50ID0gKF9pZnJhbWUuY29udGVudFdpbmRvdyB8fCBfaWZyYW1lLmNvbnRlbnREb2N1bWVudCksXG5cdFx0XHRpZnJhbWVUZXh0ID0gKGlmcmFtZUNvbnRlbnQuZG9jdW1lbnQuYm9keS5pbm5lckhUTUwpID8gaWZyYW1lQ29udGVudC5kb2N1bWVudC5ib2R5LmlubmVySFRNTCA6ICcnO1xuXHRcdFxuXHRcdGlmKCFpZnJhbWVUZXh0KXtcblx0XHRcdHJldHVybiBmYWxzZTtcblx0XHR9IFxuXG5cdFx0Y29uc3QgcmVzcG9uc2UgPSBKU09OLnBhcnNlKGlmcmFtZVRleHQpO1xuXG5cdFx0Zm9yKGNvbnN0IGVsIG9mIHJlc3BvbnNlKXtcblxuXHRcdFx0dmFyIGZpZWxkID0gX2NvbnRhY3RGb3JtLnF1ZXJ5U2VsZWN0b3IoJ1tuYW1lPScrZWwuZmllbGQrJ10nKTtcblx0XHRcdFxuXHRcdFx0c3dpdGNoKGVsLmxldmVsKXtcblx0XHRcdFx0Y2FzZSAnZXJyb3InOlxuXHRcdFx0XHRcdFxuXHRcdFx0XHRcdGlmKCFmaWVsZCkgY29udGludWU7XG5cblx0XHRcdFx0XHR0b2dnbGVFcnJvcihmaWVsZCk7XG5cdFx0XHRcdFx0XG5cdFx0XHRcdFx0Y2xhc3NMaXN0KF9idFN1Ym1pdCkuYWRkKCdrbycpO1xuXHRcdFx0XHRcdF9jb25maXJtRmllbGQuaW5uZXJIVE1MID0gZWwubXNnO1xuXHRcdFx0XHRcdGNsZWFyVGltZW91dCh0bylcblx0XHRcdFx0XHR0byA9IHNldFRpbWVvdXQoZnVuY3Rpb24oKXtjbGFzc0xpc3QoX2J0U3VibWl0KS5yZW1vdmUoJ2tvJyk7fSwgMTUwMClcblx0XHRcdFx0YnJlYWs7XG5cdFx0XHRcdGNhc2UgJ3N1Y2Nlc3MnOlxuXHRcdFx0XHRcdGlmKGVsLm1zZyA9PSBcInJlZnJlc2hcIil7XG5cdFx0XHRcdFx0XHR3aW5kb3cubG9jYXRpb24ucmVsb2FkKHRydWUpO1xuXHRcdFx0XHRcdFx0cmV0dXJuO1xuXHRcdFx0XHRcdH1cblx0XHRcdFx0XHRcblx0XHRcdFx0XHRjbGFzc0xpc3QoX2J0U3VibWl0KS5hZGQoJ29rJylcblx0XHRcdFx0XHRpZihlbC5maWVsZCA9PSBcImJ0blwiKV9idFN1Ym1pdC5zZXRBdHRyaWJ1dGUoXCJ2YWx1ZVwiLCBlbC5tc2cpXG5cdFx0XHRcdFx0aWYoZWwuZmllbGQgPT0gXCJtc2dcIilfY29uZmlybUZpZWxkLmlubmVySFRNTCA9IGVsLm1zZztcblx0XHRcdFx0XHRmb3IoY29uc3QgaW5wdXQgb2YgX2lucHV0cyl7XG5cdFx0XHRcdFx0XHRpbnB1dC5kaXNhYmxlZCA9IHRydWU7XG5cdFx0XHRcdFx0XHRpbnB1dC5yZWFkT25seSA9IHRydWU7XG5cdFx0XHRcdFx0fVxuXHRcdFx0XHRcdFxuXHRcdFx0XHRicmVhaztcblx0XHRcdH1cblx0XHR9XG5cdFx0XG5cdH1cblx0XG5cdC8qKlxuXHQgKiBcdFx0VG9nZ2xlIEVycm9yIE9uIEZpZWxkc1xuXHQgKiBcdFx0T3IgRm9yY2UgdG8gUmVtb3ZlIEVycm9yXG5cdCAqL1xuXHRjb25zdCB0b2dnbGVFcnJvciA9IChmaWVsZCwgZm9yY2VSZW1vdmUgPSBmYWxzZSk9Pntcblx0XHRzd2l0Y2goZmllbGQudGFnTmFtZSl7XG5cdFx0XHRjYXNlICdTRUxFQ1QnOlxuXHRcdFx0XHR0b2dnbGVTZWxlY3RFcnJvcihmaWVsZCxmb3JjZVJlbW92ZSk7XG5cdFx0XHRicmVhaztcblx0XHRcdGRlZmF1bHQ6XG5cdFx0XHRcdHN3aXRjaChmaWVsZC50eXBlKXtcblx0XHRcdFx0XHRjYXNlICdmaWxlJzpcblx0XHRcdFx0XHRcdHRvZ2dsZUZpbGVFcnJvcihmaWVsZCxmb3JjZVJlbW92ZSk7XG5cdFx0XHRcdFx0YnJlYWs7XG5cdFx0XHRcdFx0ZGVmYXVsdDpcblx0XHRcdFx0XHRcdHRvZ2dsZVRleHRFcnJvcihmaWVsZCxmb3JjZVJlbW92ZSk7XG5cdFx0XHRcdFx0YnJlYWs7XG5cdFx0XHRcdH1cblx0XHRcdGJyZWFrO1xuXHRcdH1cblx0fVxuXG5cdGNvbnN0IHRvZ2dsZVNlbGVjdEVycm9yID0gKGZpZWxkLGZvcmNlUmVtb3ZlKT0+e1xuXHRcdHZhciBzZWxlY3RXcmFwcGVyID0gZmllbGQucGFyZW50Tm9kZTtcblx0XHRpZihmb3JjZVJlbW92ZSl7XG5cdFx0XHRjbGFzc0xpc3Qoc2VsZWN0V3JhcHBlcikucmVtb3ZlKCdlcnJvcicpO1xuXHRcdH1lbHNle1xuXHRcdFx0Y2xhc3NMaXN0KHNlbGVjdFdyYXBwZXIpLnRvZ2dsZSgnZXJyb3InKTtcblx0XHR9XG5cdH1cblxuXHRjb25zdCB0b2dnbGVGaWxlRXJyb3IgPSAoZmllbGQsZm9yY2VSZW1vdmUpPT57XG5cdFx0aWYoZm9yY2VSZW1vdmUpe1xuXHRcdFx0Y2xhc3NMaXN0KGZpZWxkKS5yZW1vdmUoJ2Vycm9yJyk7XG5cdFx0fWVsc2V7XG5cdFx0XHRjbGFzc0xpc3QoZmllbGQpLnRvZ2dsZSgnZXJyb3InKTtcblx0XHR9XG5cdH1cblxuXHRjb25zdCB0b2dnbGVUZXh0RXJyb3IgPSAoZmllbGQsZm9yY2VSZW1vdmUpPT57XG5cdFx0aWYoZm9yY2VSZW1vdmUpe1xuXHRcdFx0Y2xhc3NMaXN0KGZpZWxkKS5yZW1vdmUoJ2Vycm9yJyk7XG5cdFx0fWVsc2V7XG5cdFx0XHRjbGFzc0xpc3QoZmllbGQpLnRvZ2dsZSgnZXJyb3InKTtcblx0XHR9XG5cdH1cbn1cbiJdfQ==